import { render, staticRenderFns } from "./comment-issue.vue?vue&type=template&id=451557d0&scoped=true"
import script from "./comment-issue.vue?vue&type=script&setup=true&lang=js"
export * from "./comment-issue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./comment-issue.vue?vue&type=style&index=0&id=451557d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451557d0",
  null
  
)

export default component.exports